import { USER } from '~/constants/wadConstants'
import {useAuthUser} from "~/composables/useAuthUser";
import dayjs from "dayjs";

export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuth()
  const { isAuthenticated, user } = useAuthUser()
  const localePath = useLocalePath()
  const config = useRuntimeConfig()

  // Logout redirect
  if (to.name && to.name.toString().startsWith('user-logout__')) {
    if (isAuthenticated) {
      await auth.signOut()
    }
    return navigateTo((to.query.redirect as string) || localePath(`${config.public.wadPlatformBaseUrl}`), { external: true })
  }

  const redirectToDevDashboardPage = () => {
    if (to.name && !to.name.toString().startsWith('developer-dashboard')) {
      return navigateTo(`${config.public.wadPlatformBaseUrl}/en/developer-dashboard?redirect=${encodeURIComponent(to.fullPath)}`, { external: true })
    }
  }

  // Developer V2 signup redirects
  if (isAuthenticated && user.value?.signup_type === USER.SIGNUP_TYPE.DEVELOPER_V2) {
    if (to.name && to.name.toString().startsWith('user-validate-email')) {
      return
    }

    const reopenTimer = Number(config.public.wadCompleteProfileReopenTimer)
    const minutesSinceLastSeen = dayjs().diff(dayjs(user.value?.complete_profile_modal_last_seen_at), 'minute')

    if (
      !user.value?.email_verified ||
      user.value?.signup_step === USER.SIGNUP_STEPS.REGISTRATION ||
      (
        user.value?.signup_step === USER.SIGNUP_STEPS.BASIC_INFO &&
        user.value?.complete_profile_modal_last_seen_at &&
        minutesSinceLastSeen > reopenTimer
      )
    ) {
      return redirectToDevDashboardPage()
    }
  }
})
